import styled from 'styled-components';

const DivCommentInput = styled.div``;

export default DivCommentInput;
